import * as React from "react";

import LogoImg from "../../assets/svg/logo.svg";

export function BigLogo() {
  return (
    <div>
      <a href={LANDING_LINK}>
        <img src={LogoImg} alt="TraceAir" />
      </a>
    </div>
  );
}
